import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <header className="bg-[#fdfbf7] pt-8 pb-10 md:pt-12 md:pb-14 px-6 overflow-hidden" data-id="element-79">
      <div className="max-w-4xl mx-auto text-center" data-id="element-80">
        <div className="inline-block px-4 py-1.5 mb-4 bg-[#1e3a5f]/10 text-[#1e3a5f] rounded-full text-sm font-semibold tracking-wide uppercase" data-id="element-81">
          Para padres cansados de pelear
        </div>

        <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#1e3a5f] leading-tight mb-4 tracking-tight" data-id="element-82">
          Tu hijo no necesita más "límites"… <br className="hidden md:block" data-id="element-83" />
          <span className="text-[#dc4a3d] underline decoration-4 underline-offset-4" data-id="element-84">
            necesita un RESET
          </span>
        </h1>

        <p className="text-lg md:text-xl text-[#2d3748] mb-6 max-w-2xl mx-auto leading-relaxed" data-id="element-85">
          30 días para que la pantalla deje de mandar en tu casa, sin gritos y
          sin convertirte en el villano.
        </p>

        <div className="mb-8 relative" data-id="element-86">
          <div className="absolute inset-0 bg-gradient-to-b from-[#fdfbf7]/0 via-[#fdfbf7]/0 to-[#fdfbf7] z-10 h-full w-full pointer-events-none" data-id="element-87" />
          <img src="https://cdn.magicpatterns.com/uploads/i2HN6DQTdnChvKsSGE5UHH/heylloyd-image-1770056377065.png" alt="Padre frustrado con hijo usando tablet en el fondo" className="rounded-2xl shadow-2xl mx-auto max-w-full md:max-w-xl border-4 border-white transform rotate-1 hover:rotate-0 transition-transform duration-500" data-id="element-88" />
        </div>

        <div className="max-w-2xl mx-auto text-left bg-white p-6 md:p-8 rounded-2xl shadow-xl border border-gray-100 relative z-20 -mt-16" data-id="element-89">
          <h3 className="text-lg font-bold text-[#1e3a5f] mb-3" data-id="element-90">
            Hay un momento que se repite en demasiadas casas.
          </h3>
          <p className="text-[#2d3748] mb-3 leading-relaxed text-sm md:text-base" data-id="element-91">
            Dices "ya se acabó"… y tu hijo cambia la cara. No es una petición.
            Es una reacción. Como si le hubieras apagado algo por dentro.
          </p>
          <p className="text-[#2d3748] mb-3 leading-relaxed text-sm md:text-base" data-id="element-92">
            En 30 segundos pasas de "todo tranquilo" a negociación, gritos,
            llanto, amenaza, portazo… o ese silencio feo que te rompe por
            dentro.
          </p>
          <p className="text-[#2d3748] font-medium italic border-l-4 border-[#dc4a3d] pl-4 py-2 bg-red-50 rounded-r-lg mb-4 text-sm md:text-base" data-id="element-93">
            Y lo peor no es el berrinche. Lo peor es la sensación de fondo:{' '}
            <br data-id="element-94" />
            <strong className="text-[#dc4a3d]" data-id="element-95">
              la pantalla manda en tu casa… y tú estás perdiendo.
            </strong>
          </p>

          <Button onClick={scrollToPricing} fullWidth size="md" icon={ArrowRight} data-id="element-96">
            Quiero recuperar el control hoy
          </Button>
          <p className="text-center text-xs text-gray-500 mt-2" data-id="element-97">
            Descarga inmediata • PDF Digital
          </p>
        </div>
      </div>
    </header>;
}